module.exports = __webpack_public_path__ + "img/2018pigc.0eb1a5a4.png";